import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";
import { SearchSelectApi } from "../../../../../../../../../services/Api/types";
import { AppState } from "../../../utils/types";

interface Props {
	appState: AppState;
	form: UseFormReturn<ApplicationUpdateApi>;
}

const InforStarlightForm = ({ appState, form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
	} = form;
	const [updatedConfig, setUpdatedConfig] = useState<Record<string, any> | undefined>(appState.config);
	const organization = useSelector(selectOrganization);

	const searchPaymentMethod = (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getPaymentMethodsSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	const updateConfig = (field: string, obj?: SearchSelectApi) => {
		const cnf = { ...updatedConfig };
		if (field === "payment_method_name") {
			cnf.payment_method_name = obj?.label;
		}
		setUpdatedConfig(cnf);
	};

	return (
		<>
			<FormSelectGroup
				name="settings.payment_method_id"
				getOptionValue={(option) => option.id}
				path={`/${organization.id}/settings/payment_methods/`}
				control={control}
				onChange={(_, fullObj) => updateConfig("payment_method_name", fullObj)}
				loadOptions={searchPaymentMethod}
				label={t("modules.app.field.default_payment_method.title")}
				defaultValue={{
					label: updatedConfig?.payment_method_name,
					id: appState.app?.settings?.payment_method_id,
				}}
				errors={errors}
				data-testid="settings.payment_method_id"
			/>
		</>
	);
};

export default InforStarlightForm;
